App.controller('TourismStartCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'Tourism_start';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Ubezpieczenie Turystyczne';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);

    if ($scope.stateParams.choose && $scope.stateParams.prices) {
        $scope.choose = $scope.stateParams.choose;
        $scope.prices = $scope.stateParams.prices;
        $scope.summary = $scope.stateParams.summary;
        $scope.persons = $scope.stateParams.persons;
    } else {
        $scope.summary = 0;
    }

    $scope.allLength = 0;
    $scope.groupwidth = [];
    $scope.singleLength = [];

    $scope.next = function () {
        $state.go('root.tourism.start', {
            persons: $scope.persons,
            choose: $scope.choose,
            prices: $scope.prices,
            summary: $scope.summary
        });
    }
}]);